export default {"src":"/_next/static/media/wordpress.fd3d2386.svg","height":114,"width":500,"blurWidth":0,"blurHeight":0};